import {
  fitnessPreferencesCheckboxGroupDefaultSelector,
  heightInputDefaultSelector,
  nutritionPreferencesCheckboxGroupDefaultSelector,
  profileInfoDefaultSelector,
  userLanguageDefaultSelector,
  weightInputDefaultSelector,
} from 'dataLayer/recoil/pages/myProfile/defaultSelectors';
import { atom } from 'recoil';

export const profileInfoAtom = atom({
  key: 'apiData/pages/myProfile/atoms/profileInfo',
  default: profileInfoDefaultSelector,
});

export const profileInfoFormSubmitAtom = atom({
  key: 'apiData/pages/myProfile/atoms/profileInfoForm',
});

export const heightInputAtom = atom({
  key: 'apiData/pages/myProfile/atoms/heightInput',
  default: heightInputDefaultSelector,
});

export const weightInputAtom = atom({
  key: 'apiData/pages/myProfile/atoms/weightInput',
  default: weightInputDefaultSelector,
});

export const userLanguageAtom = atom({
  key: 'apiData/pages/myProfile/atoms/userLanguageAtom',
  default: userLanguageDefaultSelector,
});

export const basicWellnessInfoFormSubmitAtom = atom({
  key: 'apiData/pages/myProfile/atoms/basicWellnessInfoForm',
});

export const fitnessPreferencesCheckboxGroupAtom = atom({
  key: 'apiData/pages/myProfile/atoms/fitnessPreferencesCheckboxGroup',
  default: fitnessPreferencesCheckboxGroupDefaultSelector,
});

export const fitnessPreferencesFormSubmitAtom = atom({
  key: 'apiData/pages/myProfile/atoms/fitnessPreferencesForm',
});

export const nutritionPreferencesCheckboxGroupAtom = atom({
  key: 'apiData/pages/myProfile/atoms/nutritionPreferencesCheckboxGroup',
  default: nutritionPreferencesCheckboxGroupDefaultSelector,
});

export const nutritionPreferencesFormSubmitAtom = atom({
  key: 'apiData/pages/myProfile/atoms/nutritionPreferencesForm',
});
